import React, { useState } from 'react';
import { contactEmail } from '../../data/assets';
import { faqs } from '../../data/faqs';
import { LinkButton } from '../LinkButton';
import { SplitText } from '../SplitText';
import { FaqItem } from './FaqItem';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-mist px-5 py-[5rem] sm:py-[10rem] md:px-10" data-id="element-67" data-mp="123en7bmamfth">
      <div className="mx-auto flex max-w-[71.875rem] flex-col gap-20" data-id="element-68" data-mp="1prxwnuh2wyn5">
        <SplitText as="h2" text="Questions? Answers." className="mb-0 text-[2rem] font-medium leading-[1.5] tracking-[0.47px] md:mb-8 md:tracking-[0.7px] md:text-[3.8125rem]" data-id="element-69" data-mp="1ur10jblboytj" />
        <div className="flex flex-col gap-4" data-id="element-70" data-mp="1l0z8k8pumw9c">
          {faqs.map((faq, i) => <FaqItem key={faq.question} faq={faq} index={i} open={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-71" data-mp="28rbrsfqjoff8" data-mpi={i} />)}
        </div>
        <div className="pt-0 sm:pt-4" data-id="element-72" data-mp="2oqqo3it26pj3">
          <LinkButton label="Ask us a question" href={`mailto:${contactEmail}`} variant="muted" data-id="element-73" data-mp="2jr5qpctjep8h" />
        </div>
      </div>
    </section>;
}